import { IdsInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteBlockedPlaces = (data: { centerId: number; blockedPlaces: number[] }) => {
  const { centerId, blockedPlaces } = data
  return restApiClient
    .url(
      encodeNestedObject<IdsInput>(
        constructApiUrl(API.blockedPlaces.deleteMany.url, { centerId }),
        { ids: blockedPlaces }
      )
    )
    .delete()
}

export const deleteBlockedPlace = (data: { centerId: number; blockedPlaceId: number }) => {
  const { centerId, blockedPlaceId } = data
  return restApiClient
    .url(constructApiUrl(API.blockedPlaces.delete.url, { centerId, id: blockedPlaceId }))
    .delete()
}

export const unAffectBlockedPlace = (data: { centerId: number; blockedPlaceId: number }) => {
  const { centerId, blockedPlaceId } = data
  return restApiClient
    .url(constructApiUrl(API.blockedPlaces.unAffect.url, { centerId, id: blockedPlaceId }))
    .post()
}
